class AboutUsStorySection extends HTMLElement {
  constructor() {
    super();
    this.emojis = this.querySelectorAll('.about-us-story__emoji');
    this.mainContent = document.querySelector('.main-content');

    document.addEventListener('DOMContentLoaded', this.firstColorBackground.bind(this));

    this.emojis.forEach(emoji => {
      emoji.addEventListener('click', this.onEmojiClick.bind(this));
    })
  }

  firstColorBackground() {
    this.mainContent.className = `main-content ${this.dataset.firstColor}`;
  }

  onEmojiClick(e) {
    const currentEmoji = e.target.closest('.about-us-story__emoji');
    if (currentEmoji.classList.contains('active')) return;

    // 1. 'active' class
    this.emojis.forEach(el => el.classList.remove('active'));
    currentEmoji.classList.add('active');

    // 2. Change section background
    this.mainContent.className = `main-content ${currentEmoji.dataset.color}`;
  }
}

customElements.define('about-us-story-section', AboutUsStorySection)